import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../components/list/ListHeader';
import TableUI from '../components/list/TableUI';
import FilterPannel from '../components/filter/FilterPannel';
import HeaderViewList from '../components/list/HeaderViewList';

import Const from '../util/Constants';
import withRouter from '../util/WithRouter';
import MeetingAPI from '../api/MeetingAPI';
import KeyValueAPI from '../api/KeyValueAPI';
import MeetingPopup from '../components/meeting/MeetingPopup';
import Util from '../util/Util';
import ImportExportAPI from '../api/ImportExportAPI';
import ViewController from '../controller/ViewController';
import DB from '../util/LocalDB';

class MeetingList extends React.Component {

  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    const filters = query.get("filters") ? JSON.parse(query.get("filters")) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.meeting;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Meeting);
    this.view = this.views.find(view => view.id === (filters ? 0 : cView.meeting ? cView.meeting : 0));
    if(!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }

    this.actions = DB.getActions(Const.Meeting);

    this.lists = reactLocalStorage.getObject(Const.ListMeeting);
    if (!(this.lists instanceof Array)) {
      if (Object.keys(this.lists).length !== 0) {
        const lists = [];
        lists.push({ ...this.lists, view: 0 });
        this.lists = lists;
      } else {
        this.lists = [];
      }
    }
    this.setList(filters);
    
    this.data = { meetings: [], count: 0 };
    this.state = { inApiCall: true, isFilterOpen: this.list.isFilterOpen, meeting: null, id: 0, type: 0 };
    
    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
  }

  componentDidMount() { if(this.List) this.loadMeetings(); }

  setList = (filters) => {
    this.list = this.lists.find((list) => list.view === this.view.id);
    let fields = ['model', 'date_time', 'responsible_person', 'feedback', 'comment', 'complete', 'created_by', 'created_date'];
    if (!this.list) {
      this.list = { view: this.view.id };
      let tmpField = reactLocalStorage.getObject(Const.FieldList);
      if (tmpField && tmpField.meeting) {
        if (typeof tmpField.meeting[0] === "string" && this.view.id === 0) {
          this.list.fields = tmpField.meeting;
        } else if (typeof tmpField.meeting[0] === "object" && this.view.id === 0) {
          const tmp = tmpField.meeting.find((item) => item.view === this.view.id);
          if (tmp) {
            fields = tmp.fields;
          }
        } else if (
          this.view.fields &&
          this.view.fields.length > 0 &&
          this.view.fields[0]
        ) {
          fields = this.view.fields;
        }
      } else if (
        this.view.fields &&
        this.view.fields.length > 0 &&
        this.view.fields[0]
      ) {
        fields = this.view.fields;
      }
      this.list.fields = fields;
      this.list.filters = [];
      this.list.pagination = { currentPage: 1, pageCount: 1, perPage: 10 };

      this.lists.push(this.list);
    } else {
      if(this.view && this.view.fields && this.view.fields.length > 3) {
        this.list.fields = this.view.fields;
      }
    }

    this.list.fields = this.list.fields.filter((field) => {
      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    if (filters) {
      this.list.filters = filters;
    }
  };

  saveListFields = (fields) => {
    let tmpField = reactLocalStorage.getObject(Const.FieldList);
    if (tmpField.meeting) {
      if (typeof tmpField.meeting[0] === "string") {
        tmpField.meeting = [{ fields: tmpField.meeting, view: 0 }];
      }
      const tmp = tmpField.meeting.find((item) => item.view === this.view.id);
      if (tmp) {
        tmp.fields = fields;
      } else {
        tmpField = { ...tmpField, meeting: [...tmpField.meeting, { view: this.view.id, fields }] };
      }
    } else {
      tmpField = { ...tmpField, meeting: [{ view: this.view.id, fields }] };
    }
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  };

  saveListSort = sort => {
    let fieldList = reactLocalStorage.getObject(Const.FieldList);
    if(!fieldList) fieldList = { };
    fieldList = { ...fieldList, meeting_sort: sort };
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, fieldList, () => {});
  }

  loadMeetings = () => {
    reactLocalStorage.setObject(Const.ListMeeting, this.lists);
    const mainFilters = ViewController.getRestrictionsView(Const.Meeting);
    const filters = ViewController.filters( [...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true });
    MeetingAPI.getList({ ...this.list, filters }, this.onReceived, this.onFail);
  }

 onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  onReceived = res => {
    this.data.meetings = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  }

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.loadMeetings();
  }

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.loadMeetings();
  }

  onFieldSelection = (fields) => {
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadMeetings();
  }

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    reactLocalStorage.setObject(Const.ListMeeting, this.list);
    this.saveListSort(this.list.sorting);
    this.loadMeetings();
  }

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListMeeting, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  }
  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => { this.list.filters = filters; this.loadMeetings(); }

  onAddEdit = index => this.setState({ ...this.state, meeting: this.data.meetings[index] });
  onPreview = index => { 
    const meeting = this.data.meetings[index];
    if(meeting.model_no === Const.Lead) {
      this.props.navigate(`/lead/preview/${meeting.model_id}`);
    } else if(meeting.model_no === Const.Contact) {
      this.props.navigate(`/contact/preview/${meeting.model_id}`);
    }
  }
  onDelete = index => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      MeetingAPI.delete(this.data.meetings[index].id, this.onDeleteSuccess, this.onFail);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Call deleted successfully', 'success');
    this.loadMeetings();
  }

  hidePopUp = () => this.setState({ ...this.state, meeting: null});

  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    +` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      const filters = ViewController.filters( [...this.list.filters], this.view.filters, this.Restrict);
      ImportExportAPI.exportModel(Const.Meeting, filters, this.list.sorting, this.data.count, fields, this.model.model_no,
        this.onExport, this.onFail);
  });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Meeting Exported in progress.'
      + ' Please visit Settings', 'success');
  }

  onTabClick = (view) => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.meeting = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadMeetings();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  render() {
    if(!this.List) return null;

    return (
      <div>
        <MeetingPopup show={this.state.meeting} onHide={this.hidePopUp} meeting={this.state.meeting} reload={this.loadMeetings} lead={{ firstname: this.state.meeting?.lead_first, lastname: this.state.meeting?.lead_last }} />

        <HeaderViewList
          views={this.views}
          view={this.view}
          onTabClick={this.onTabClick}
        />

        <ListHeader name={this.model.label_name} pagination={this.list.pagination} model={this.model}
          listCount={this.data.count} filterCount={this.list.filters.length}
          onPageChange={this.onPageChange} perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange} toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(0)} add={false} export={this.export} />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.meetings}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              onFieldChange={this.onFieldChange}
              preview={true}
              update={this.Update}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              isFilterOpen={this.state.isFilterOpen}
              onFieldSelection={this.onFieldSelection}
              onOrderChange={this.onOrderChange}
              actions={this.actions} />

            <FilterPannel filters={this.list.filters} fields={this.model.fields}
              onFilterChange={this.onFilterChange} isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
              closeFilter={this.closeFilter} />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(MeetingList);